import React, { useState, useEffect } from 'react';
import './trans.css';
/* Change logo here too */ import logo from './img/lgo.png';
import html2pdf from 'html2pdf.js';
import { XCircle } from 'react-feather';

const Transcript = () => {
  const savedData = localStorage.getItem('transcripts');
  const initialData = savedData ? JSON.parse(savedData) : [];

  const [formData, setFormData] = useState({
    name: '',
    matriculationNumber: '',
    class: '',
    faculty: '',
    department: '',
    year: '',
    image: null,
    courses: [{ code: '', title: '', credit: '', grade: '' }],
  });

  const [transcripts, setTranscripts] = useState(initialData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCourseChange = (index, e) => {
    const { name, value } = e.target;
    const updatedCourses = [...formData.courses];
    updatedCourses[index][name] = value;
    setFormData((prevData) => ({
      ...prevData,
      courses: updatedCourses,
    }));
  };

  const addCourse = () => {
    setFormData((prevData) => ({
      ...prevData,
      courses: [...prevData.courses, { code: '', title: '', credit: '', grade: '' }],
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevData) => ({
          ...prevData,
          image: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newTranscript = generateTranscriptHTML();
    const newTranscripts = [
      { name: formData.name, transcript: newTranscript, image: formData.image },
      ...transcripts,
    ];
    setTranscripts(newTranscripts);
    localStorage.setItem('transcripts', JSON.stringify(newTranscripts));
  };

const generateTranscriptHTML = () => {
  const courseGPAs = formData.courses.map(course => {
    const gradePercentage = course.grade / 100;
    return gradePercentage * 4 * course.credit;
  });

  const totalCredits = formData.courses.reduce((sum, course) => sum + Number(course.credit), 0);
  const totalGrades = formData.courses.reduce((sum, course) => sum + Number(course.grade), 0);
  const averageGrade = totalGrades / formData.courses.length;
  const totalGPA = courseGPAs.reduce((sum, gpa) => sum + gpa, 0) / totalCredits;

  return `
    <!DOCTYPE html>
    <html lang="fr">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Relevé de Notes Universitaire</title>
      <style>
          body { font-family: Arial, sans-serif; margin: 0; padding: 20px; background-color: #f9f9f9; }
          .transcript-container { width: 800px; margin: 0 auto; background-color: #fff; padding: 20px; border: 1px solid #ddd; border-radius: 5px; }
          .header { margin-bottom: 20px; }
          .school-info { display: flex; font-family: monospace; }
          .school-info img { width: 220px; height: auto; margin-right: 0px; }
          .student-info {display: flex; justify-content: space-between; flex-direction: row; }
          .transcript-table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 14px; }
          .transcript-table th, .transcript-table td { padding: 8px; text-align: right; border: 1px solid #000; }
          .transcript-table .year-info-cell { font-weight: bold; text-align: center; vertical-align: middle; }
          .total-gpa { margin-top: 10px; text-align: left; font-weight: bold; }
          .student-image { width: 140px; margin-bottom: 0px; }
      </style>
    </head>
    <body>
      <div class="transcript-container">
        <div class="header">
            <div class="school-info">
              <img src="${logo}" alt="Logo de l'Université">
              <div>
                <h4 style="text-transform: uppercase;">Université de Kalemie</h4>
                <p style="font-size: 18px; text-transform: uppercase;">Scientia splendet et conscientia</p>
                <p>Email: unikal.ac.cd<br/>
                Site web: rectorat@unikal.ac.cd</p>
              </div>
            </div>
        </div>
        <div class="student-info">
          <div>
            <p><strong>Nom:</strong> ${formData.name}</p>
            <p><strong>Matricule:</strong> ${formData.matriculationNumber}</p>
            <p><strong>Faculté:</strong> ${formData.faculty}</p>
            <p><strong>Département:</strong> ${formData.department}</p>
          </div>
          <div>
            ${formData.image ? `<img src="${formData.image}" alt="Student Image" class="student-image" />` : ''}
          </div>
        </div>
        <table class="transcript-table">
          <thead>
            <tr>
              <th>Année Academique</th>
              <th>Code</th>
              <th>Titre des cours</th>
              <th>Crédit</th>
              <th>Notes/100</th>
              <th>GPA</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="${formData.courses.length}" class="year-info-cell"> ${formData.class}</br>${formData.year}</td>
              <td>${formData.courses[0].code}</td>
              <td>${formData.courses[0].title}</td>
              <td style="text-align: right;">${formData.courses[0].credit}</td>
              <td style="text-align: right;">${formData.courses[0].grade}</td>
              <td style="text-align: right;">${(courseGPAs[0] / formData.courses[0].credit).toFixed(2)}</td>
            </tr>
            ${formData.courses.slice(1).map((course, index) => `
              <tr>
                <td>${course.code}</td>
                <td>${course.title}</td>
                <td style="text-align: right;">${course.credit}</td>
                <td style="text-align: right;">${course.grade}</td>
                <td style="text-align: right;">${(courseGPAs[index + 1] / course.credit).toFixed(2)}</td>
              </tr>
            `).join('')}
            <tr>
              <td colspan="3"><strong>Total</strong></td>
              <td>${totalCredits}</td>
              <td>${averageGrade.toFixed(2)}</td>
              <td>${totalGPA.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </body>
    </html>
  `;
};

const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedTranscript, setSelectedTranscript] = useState(null);



  const openTranscriptInNewTab = (transcriptHTML) => {
    const newWindow = window.open();
    newWindow.document.write(transcriptHTML);
    newWindow.document.close();
  };

  const handleTranscriptClick = (index) => {
    setSelectedTranscript(transcripts[index]);
    setIsModalOpen(true);
  };

  const handleClickOutside = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      setIsModalOpen(false);
      setSelectedTranscript(null);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isModalOpen]);


  const handleDeleteTranscript = (index) => {
    const updatedTranscripts = transcripts.filter((_, i) => i !== index);
    setTranscripts(updatedTranscripts);
    localStorage.setItem('transcripts', JSON.stringify(updatedTranscripts));
  };

  const handleDownloadPDF = (index) => {
    const transcriptHTML = transcripts[index].transcript;
    const element = document.createElement('div');
    element.innerHTML = transcriptHTML;

    const options = {
      filename: 'transcript.pdf',
      html2canvas: { x: -30, y: -20, scale: 2 , width: 900},
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    html2pdf()
      .from(element)
      .set(options)
      .save();
  };

  useEffect(() => {
    const savedData = localStorage.getItem('transcripts');
    const initialData = savedData ? JSON.parse(savedData) : [];
    setTranscripts(initialData);

    if (initialData.length > 0) {
      const savedImage = initialData[0].image;
      setFormData((prevData) => ({
        ...prevData,
        image: savedImage,
      }));
    }
  }, []);


  return (
    <div className="transcript-wrapper">
      <div className="form-blt">
        <img src={logo} className="form-logo" alt="Logo" />
        <form onSubmit={handleSubmit} className='trans-form' >
          {/* Form Inputs */}
          <div>
            <input
              type="text"
              name="name"
              placeholder="Names"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <input
              type="text"
              name="matriculationNumber"
              placeholder="Matricule"
              value={formData.matriculationNumber}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <input
              type="text"
              name="class"
              placeholder="Class"
              value={formData.class}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <input
              type="text"
              name="faculty"
              placeholder="Faculty"
              value={formData.faculty}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <input
              type="text"
              name="department"
              placeholder="Department"
              value={formData.department}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <input
              type="text"
              name="year"
              placeholder="Year"
              value={formData.year}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <input
              type="file"
              onChange={handleImageChange}
            />
          </div>
          {/* Course Fields */}
          <div>
            {formData.courses.map((course, index) => (
              <div key={index}>
                <br/>
                <input
                  type="text"
                  name="title"
                  placeholder="Titre du cour"
                  value={course.title}
                  onChange={(e) => handleCourseChange(index, e)}
                  required
                />
                <input
                  type="text"
                  name="code"
                  placeholder="Code"
                  value={course.code}
                  onChange={(e) => handleCourseChange(index, e)}
                  required
                />
                <br/>
                <input
                  type="number"
                  name="credit"
                  placeholder="Credit"
                  value={course.credit}
                  onChange={(e) => handleCourseChange(index, e)}
                  required
                />
                <input
                  type="number"
                  name="grade"
                  placeholder="Grade"
                  value={course.grade}
                  onChange={(e) => handleCourseChange(index, e)}
                  required
                />
              </div>
            ))}
          <button className='download-button' type="button" onClick={addCourse}>Ajoutez un Cour</button>
          <button className='download-button' type="submit">Générer le Bulletin</button>
          </div>
        </form>
      </div>
      <div className="transcript-output">
        {/* Display generated transcripts */}
        {transcripts.length > 0 && (
          <div>
            <h3 style={{fontFamily: "monospace"}}>Bulletin disponible</h3>
            <div >
              {transcripts.map((transcript, index) => (
                <div className='name-space'>
                  <div key={index}>
                    <button onClick={() => handleTranscriptClick(index)} className='name-tag'>
                      {transcript.name}
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => handleDeleteTranscript(index)}
                      className="crud-btn" id='crd-delete'
                    >
                      Supprimer
                    </button>
                    <button
                      onClick={() => handleDownloadPDF(index)}
                      className="crud-btn"
                    >
                      Telecharger
                    </button>
                  </div>
                  </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {isModalOpen && (
  <div className="modal-overlay">
    <div className="modal-content">
      <div dangerouslySetInnerHTML={{ __html: selectedTranscript?.transcript }}/>
    </div>
      <button className="close-modal-btn" onClick={() => setIsModalOpen(false)}>
        <XCircle size={28}/>
      </button>
  </div>
)}
    </div>
  );
};

export default Transcript;
